import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})
export class SuccessComponent {

  @Input() successData:any;

  constructor(
    private router:Router,
    private headerService:HeaderService
  ){
  }

  ngOnInit(){
    
  }

  buttonClick(){
    if(this.successData.btnText == 'success.done'){
      this.headerService.updateShowHeader(true);
      this.headerService.updateHeaderDetails({displayOnlyLogo:false});
      this.router.navigate(['/home/profile']);
    }
    else{
      this.router.navigate(['/login']);
    }
  }

}
